export const departmentColors = [
  {
    button: '#FFD3CF',
    text: '#EE524F'
  },

  {
    button: '#BFC9DE',
    text: '#254489'
  },

  {
    button: '#D8F7D9',
    text: '#62AE64'
  },

  {
    button: '#D4BFB8',
    text: '#5D4942'
  },

  {
    button: '#CDE3F8',
    text: '#4891DA'
  },

  {
    button: '#FCFFD1',
    text: '#AFB42A'
  },

  {
    button: '#EADEFF',
    text: '#A17EDE'
  },

  {
    button: '#CBFDF6',
    text: '#32CAB6'
  },

  {
    button: '#FFE8CA',
    text: '#FFA12B'
  },

  {
    button: '#CFE0E8',
    text: '#5E7B89'
  },

  {
    button: '#D7C8F1',
    text: '#8060B7'
  },

  {
    button: '#C4EDE9',
    text: '#2A9C90'
  },

  {
    button: '#FFE9E3',
    text: '#FF8862'
  },

  {
    button: '#ADB8BD',
    text: '#35454D'
  },

  {
    button: '#FDEBF1',
    text: '#F4A1BD'
  },

  {
    button: '#F2E9E6',
    text: '#9F867E'
  },

  {
    button: '#F6E5F8',
    text: '#C793CF'
  },

  {
    button: '#DCF0FE',
    text: '#69B0E2'
  },

  {
    button: '#FFF6DE',
    text: '#F1BC35'
  },

  {
    button: '#E9F3F8',
    text: '#7A929D'
  }
]
/*
export const roomTypeColors = [
  {
    button: '#FFD3CF',
    text: '#F93C3C'
  },
  {
    button: '#F4D895',
    text: '#caae76'
  },
  {
    button: '#56d64a',
    text: '#428b38'
  },
  {
    button: '#00e2be',
    text: '#009A7F'
  },
  {
    button: '#e2ebee',
    text: '#9FA8AB'
  },
  {
    button: '#97e1ed',
    text: '#62929E'
  },
  {
    button: '#ca9865',
    text: '#684E32'
  },
  {
    button: '#8bb5c8',
    text: '#546A7B'
  },
  {
    button: '#ffd6f8',
    text: '#987691'
  },
  {
    button: '#e18756',
    text: '#864A39'
  },
  {
    button: '#f2d7c2',
    text: '#a18c7a'
  },
  {
    button: '#DCF0FE',
    text: '#69B0E2'
  },

  {
    button: '#FFF6DE',
    text: '#F1BC35'
  },

  {
    button: '#E9F3F8',
    text: '#7A929D'
  },
  {
    button: '#D8F7D9',
    text: '#62AE64'
  },

  {
    button: '#D4BFB8',
    text: '#5D4942'
  },

  {
    button: '#CDE3F8',
    text: '#4891DA'
  },

  {
    button: '#FCFFD1',
    text: '#AFB42A'
  },

  {
    button: '#EADEFF',
    text: '#A17EDE'
  }
]
*/

export const roomTypeColors = [
  {
    roomCat: '110',
	button: '#bd8ce3',
    text: 'black'
  },
  {
	roomCat: '210',
	button: '#bd8ce3',
    text: 'black'
  },
  {
	roomCat: '350',
	button: '#b8e6b1',
    text: 'black'
  },  
  {
	roomCat: 'AAA',
	button: '#ffff00',
    text: 'black'
  },
  {
	roomCat: 'XXX',
	button: '#0071E6',
    text: 'white'
  },
  {
	roomCat: 'WWW',
	button: '#646669',
    text: 'white'
  },
  {
	roomCat: 'YYY',
	button: '#646669',
    text: 'white'
  },
  {
	roomCat: 'ZZZ',
	button: '#ff552e',
    text: 'black'
  },
  {
	roomCat: '',
	button: '#009E73',
    text: 'black'
  }
]
